export enum CoreDataActionName {
  CategoriesLoadAll = '[Core Data Categories] Load All',
  CodesLoadAll = '[Core Data Codes] Load All',
  CompaniesLoadAll = '[Core Data Companies] Load All',
  JobTypesLoadAll = '[Core Data Job Types] Load All',
  PrioritiesLoadAll = '[Core Data Priorities] Load All',
  WorkorderStatusLoadAll = '[Core Data Workorder Status] Load All',
  QuoteStatusLoadAll = '[Core Data Quote Status] Load All',
  RoleLoadAll = '[Core Data Roles] Load All',
  UsersLoadAll = '[Core Data Users] Load All',
  ZonesLoadAll = '[Core Data Zones] Load All',
  CustomersLoadAll = '[Core Data Customers] Load All',
  DocumentsLoadAll = '[Core Data Documents] Load All',
  ActionSuccess = '[Core Data] Action Success',
  ActionFailed = '[Core Data] Action Failed'
}
